
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "t": "1729477985044",
    "class": "icon",
    "viewBox": "0 0 1024 1024",
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "p-id": "2603",
    "width": "16",
    "height": "16"
  },
  "children": [
    {
      "tag": "path",
      "attrsMap": {
        "d": "M14.278687 494.72555121L312.91147481 788.51184055l0-172.82492782L711.08852519 615.68691273 711.08852519 788.51184055 1009.721313 494.72555121 711.08852519 235.48815945l0 172.82492782-398.17705038 0 0-172.82492782-298.63278781 259.23739176z",
        "fill": "#2c2c2c",
        "p-id": "2604"
      }
    }
  ]
})
    }
  